import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from './Modal_EnterPassword';
import { ProjectDetailsModal } from './Modal_DetailData_Project';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewProjectsModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [viewExpenses, setViewExpenses] = useState([]);

    let [projectID, setProjectID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [deletTracker, setDeleteTracker] = useState(null);

    let [showProjectDetailsModal, setShowProjectDetailsModal] = useState(false);
    let [projectTotalEstimates, setProjectTotalEstimates] = useState(false);
    let [projecTotalExpenses, setProjecTotalExpenses] = useState(false);

    useEffect(() => {



        if(props.openModal == true && startDate != null && endDate != null)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A');
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_view_projects',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');



                    setViewExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            projectID: cols[0],
                            projectName: cols[1],
                            projectTimeCreated: new Date(cols[2]).toISOString().substr(0, 10),
                            projectForm: cols[3],
                            projectTotalEstimates: parseFloat(cols[4]).toFixed(2),
                            projecTotalExpenses: parseFloat(cols[5]).toFixed(2),
                            projectDescripton: cols[6],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function deleteProject(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xExpenseID', projectID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: deletTracker,
                user: acctID,
                xProjectID: projectID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewExpenses([]);
        props.closeModal(event);

    }
 
    function viewProjectDetailsHandler(event) {


        setProjectID(event[1]);
        setTotalAmount(event[2]);

        setShowProjectDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteProjectHandler(event) {


        setShowPasswordModal(event[0]);
        setProjectID(event[1]);
        setDeleteTracker(event[2])
    }

    function onSubmitPasswordHandler(event)
    {
        deleteProject(event);
    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3> One-Time Expenses </h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='1'>  ID </IonCol>
                                    <IonCol size='8'> Name </IonCol>
                                    {/*<IonCol size='2'> Date </IonCol>*/}
                                    {/*<IonCol size='2'> Estimate </IonCol>*/}
                                    {/*<IonCol size='2'> Expenses </IonCol>*/}                                                                             
                                    <IonCol size='3'> Action </IonCol>
                            </IonRow>
                        {viewExpenses.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.projectID}>
                                        <IonCol size='1'>{detailData.projectID}</IonCol>
                                        <IonCol size='8'>{detailData.projectName}</IonCol>
                                        {/*<IonCol size='2'>{detailData.projectTimeCreated}</IonCol>*/}
                                        {/*<IonCol size='2'>{detailData.projectTotalEstimates}</IonCol>*/}
                                        {/*<IonCol size='2'>{detailData.projecTotalExpenses}</IonCol>*/}
                                        <IonCol size='3'>

                                            <IonButton className='appListButton' onClick={() => viewProjectDetailsHandler([true, detailData.projectID, detailData.projecTotalExpenses])}> Details </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteProjectHandler([true, detailData.projectID, '74002D_delete_project_hard'])}> H-Delete </IonButton>}
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteProjectHandler([true, detailData.projectID, '74002D_delete_project_soft'])}> S-Delete </IonButton>}
                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                        <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

                        <ProjectDetailsModal openModal={ showProjectDetailsModal } closeModal={() => setShowProjectDetailsModal(false)} data={{
                                            projectID: projectID, 
                                            estimates: projectTotalEstimates,
                                            expenses: projecTotalExpenses,
                                            }}></ProjectDetailsModal>

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}